import type { DebtAsset } from "~/types/assets.types";
import { calculateOwnership } from "../genericCalculations/ownership";

export const calculateDebtMonthlyRefund = (userProduct: DebtAsset) => {
  const routes = userProduct?.routesData || [];
  const ownership = userProduct?.ownership || 0;

  const monthlyRefund = routes.reduce((sum, current) => {
    const refund = current?.monthlyRepayment || 0;

    return sum + refund;
  }, 0);

  return calculateOwnership(monthlyRefund, ownership);
};
